/** Coarse file-type bucket for patient_document_uploaded (schema known values). */
export type PatientDocumentFileType = 'pdf' | 'image' | 'text' | 'other';

/** Buckets a MIME type into the analytics file_type known values. */
export const toAnalyticsFileType = (mimeType: string): PatientDocumentFileType => {
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.startsWith('text/')) return 'text';
  return 'other';
};
